import { GenericFilter } from '@/components/GenericFilter';
import type { ListFacilityFilterType, ListFacilityFilterTypeWithValues } from '@shelflix/schemas/facility/list';

export function FacilityFilter({ onChange }: { onChange: (filters: ListFacilityFilterTypeWithValues) => void }) {
  const options: ListFacilityFilterType = {
    search: {
      label: 'CNPJ',
      fields: ['cnpj'],
    },
    filter: [
      {
        label: 'Estado',
        field: { name: 'state', condition: 'equals' },
        items: [
          { text: 'AC', value: 'AC' },
          { text: 'AL', value: 'AL' },
          { text: 'AP', value: 'AP' },
          { text: 'AM', value: 'AM' },
          { text: 'BA', value: 'BA' },
          { text: 'CE', value: 'CE' },
          { text: 'DF', value: 'DF' },
          { text: 'ES', value: 'ES' },
          { text: 'GO', value: 'GO' },
          { text: 'MA', value: 'MA' },
          { text: 'MT', value: 'MT' },
          { text: 'MS', value: 'MS' },
          { text: 'MG', value: 'MG' },
          { text: 'PA', value: 'PA' },
          { text: 'PB', value: 'PB' },
          { text: 'PR', value: 'PR' },
          { text: 'PE', value: 'PE' },
          { text: 'PI', value: 'PI' },
          { text: 'RJ', value: 'RJ' },
          { text: 'RN', value: 'RN' },
          { text: 'RS', value: 'RS' },
          { text: 'RO', value: 'RO' },
          { text: 'RR', value: 'RR' },
          { text: 'SC', value: 'SC' },
          { text: 'SP', value: 'SP' },
          { text: 'SE', value: 'SE' },
          { text: 'TO', value: 'TO' },
        ],
      },
    ],
  };

  return <GenericFilter options={options} onChange={onChange} />;
}
